//
//

import { mapGetters, mapActions, mapMutations } from "vuex";
import i18n from "@/i18n/index";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    name: "ImportExportModal",
    components: { AQModal, AQButton, AQUploader, AQDialog },
    props: { fromCatalogsList: Boolean, value: Boolean },
    data() {
        return {
            url: "",
            showModal: true,
            response: false,
            catListExpExcel: [],
            addedFile: null,
            fileType: "xls",
            incorrectFileDialog: false,
            dupCodeNameDialog: false,
            importButton: {
                label: this.$t("catalogs.importExport.import"),
                disabled: true
            }
        };
    },
    computed: {
        ...mapGetters("catalogs", [
            "items",
            "selectedCatalogName",
            "selectedCatalogData",
            "selectedCat"
        ]),
        ...mapGetters("apps", ["currentApp"]),
        titleModal() {
            return this.fromCatalogsList ? `${this.$t("catalogs.importExport.titleBulk")}` : `${this.$t("catalogs.importExport.title")}`;
        }
    },
    mounted() {
        this.actionsDlg.bind(this);
    },
    methods: {
        ...mapActions("catalogs", [
            "getCatList",
            "getTableDetails",
            "expCatListExcel",
            "expCatListJson",
            "uplCatList",
            "uplCatListJson"
        ]),
        ...mapMutations("catalogs", ["setTableDetails", "setCurrApp"]),
        ...mapMutations("main", ["setInterfaceDirty"]),
        ...mapActions("apps", ["getAppSettingsInfo"]),
        actionsDlg($event) {
            if ($event === "save") {
                this.uploadFile();
            } else {
                this.showModal = false;
                this.$emit("modalClosed", true);
            }
        },
        modalClosed() {
            this.$emit("modalClosed");
        },
        checkFreshAppData() {
            this.getAppSettingsInfo(this.currentApp).then(data => {
                this.currentApp.publishStatus = data.data.publishStatus;
                this.$store.commit("apps/setCurrentApp", this.currentApp);
            });
        },
        importJsnFile(exportedData, fileName) {
            this.$store.commit("catalogs/setDataFromImport", []);
            const contentType = "multipart/form-data";
            const dataForm = new FormData();
            this.$store.commit("catalogs/setFromImportExcel", true);
            const fileBlob = new Blob([exportedData], { type: contentType });
            dataForm.append("attachment", fileBlob, fileName);
            if (this.fromCatalogsList) {
                this.uplCatListJson(dataForm).then(
                    () => {
                        this.$emit("refreshCatList");
                        this.showModal = false;
                        this.$emit("modalClosed", true);
                        this.$root.$emit("showCheckedSaveBtn", true);
                        this.$store.commit("main/setInterfaceDirty", false);
                        this.showSuccessNotify();
                        this.checkFreshAppData();
                    },
                    error => {
                        this.showModal = false;
                        this.$emit("modalClosed", true);
                        this.$toast.showNotify({
                            type: "error",
                            message: this.errorMsgHandler(error.response.data.error, false),
                            timeout: 1000
                        });
                    }
                );
            } else {
                this.uplCatListJson(dataForm).then(
                    () => {
                        this.getCatList();
                        const copySelCat = this.selectedCat;
                        this.getTableDetails(copySelCat);
                        this.showSuccessNotify();
                        this.showModal = false;
                        this.$root.$emit("showCheckedSaveBtn", true);
                        this.$store.commit("main/setInterfaceDirty", false);
                        this.checkFreshAppData();
                        this.$emit("modalClosed", true);
                    },
                    error => {
                        this.showModal = false;
                        this.$emit("modalClosed", true);
                        this.$toast.showNotify({
                            type: "error",
                            message: this.errorMsgHandler(error.response.data.error, false),
                            timeout: 1000
                        });
                    }
                );
            }
        },

        importJson(file) {
            if (!file) return;
            this.importJsnFile(file, file.name);
        },
        errorMsgHandler(excepMsg, fromXLSCat) {
            let msgToShow = fromXLSCat ? excepMsg || i18n.t("catalogs.importExport.importDupCodeName") : excepMsg;
            if (excepMsg && excepMsg.includes("No catalog with") && !fromXLSCat) {
                msgToShow = i18n.t("catalogs.importExport.importXlsCatListErr");
            } else if (excepMsg && excepMsg.includes("allowed length for code is 50")) {
                msgToShow = i18n.t("catalogs.importExport.importMaxLengthErr");
            } else if (excepMsg && excepMsg.includes("Duplicate name found")) {
                const match = excepMsg.match(/:([^:]*)$/);
                msgToShow = i18n.t("catalogs.importExport.duplicateColName") + match[1].trim();
            } else if (excepMsg && excepMsg.includes("Duplicate code found")) {
                const match = excepMsg.match(/:([^:]*)$/);
                msgToShow = i18n.t("catalogs.importExport.duplicateColCode") + match[1].trim();
            } else if (excepMsg && excepMsg.includes("Duplicate value in column name")) {
                const match = excepMsg.match(/:\s*(\S+)/);
                msgToShow = i18n.t("catalogs.importExport.duplicateColName") + match[1];
            } else if (excepMsg && excepMsg.includes("Duplicate value in column code")) {
                const match = excepMsg.match(/:\s*(\S+)/);
                msgToShow = i18n.t("catalogs.importExport.duplicateColCode") + match[1];
            } else if (excepMsg && excepMsg.includes("Code cannot be empty")) {
                msgToShow = i18n.t("catalogs.importExport.codeErrEmpty");
            } else if (excepMsg && excepMsg.includes("Name cannot be empty")) {
                msgToShow = i18n.t("catalogs.importExport.nameErrEmpty");
            }
            return msgToShow;
        },
        importXls(file) {
            const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            const dataForm = new FormData();
            this.$store.commit("catalogs/setFromImportExcel", true);
            let fileBlob;
            if (file) {
                fileBlob = new Blob([file], { type: contentType });
                dataForm.append("attachment", fileBlob, file.name);
                if (this.fromCatalogsList) {
                    this.uplCatList(dataForm).then(
                        () => {
                            this.$emit("refreshCatList");
                            this.showModal = false;
                            this.$emit("modalClosed", true);
                            this.$root.$emit("showCheckedSaveBtn", true);
                            this.$store.commit("main/setInterfaceDirty", false);
                            this.showSuccessNotify();
                            this.checkFreshAppData();
                        },
                        error => {
                            this.showModal = false;
                            this.$emit("modalClosed", true);
                            this.$toast.showNotify({
                                type: "error",
                                message: this.errorMsgHandler(error.response.data.error, false),
                                timeout: 1000
                            });
                        }
                    );
                } else {
                    this.uplCatList(dataForm).then(
                        () => {
                            this.getCatList();
                            const copySelCat = this.selectedCat;
                            this.getTableDetails(copySelCat);
                            this.showSuccessNotify();
                            this.$root.$emit("showCheckedSaveBtn", true);
                            this.$store.commit("main/setInterfaceDirty", false);
                            this.checkFreshAppData();
                        },
                        error => {
                            this.$toast.showNotify({
                                type: "error",
                                message: this.errorMsgHandler(error.response.data.error, true)
                            });
                        }
                    );
                }
            }
        },
        inputUpdateChanged(files) {
            [this.addedFile] = files;
            if (files[0].type === "application/json") {
                this.fileType = "json";
            } else {
                this.fileType = "xls";
            }
            this.importButton.disabled = false;
        },
        removedFile() {
            this.importButton.disabled = true;
        },
        uploadFile() {
            const fileName = this.addedFile.name.split("-export");
            this.$root.$emit("disableSaveButton", false);

            if (this.fromCatalogsList) {
                if (this.fileType === "json") {
                    this.importJson(this.addedFile);
                } else {
                    this.importXls(this.addedFile);
                }
            } else if (this.selectedCat.name === fileName[0]) {
                if (this.fileType === "json") {
                    this.importJson(this.addedFile);
                } else {
                    this.importXls(this.addedFile);
                    this.$emit("modalClosed", true);
                }
            } else {
                this.incorrectFileDialog = true;
                this.showModal = true;
            }
        },

        exportCatList(fromXls) {
            const catListExpExcel = [];
            let sendListXls = [];
            const currApp = this.currentApp;
            this.$store.commit("catalogs/setCurrApp", currApp);
            if (fromXls) {
                if (this.fromCatalogsList) {
                    this.items.forEach(element => {
                        catListExpExcel.push(element.name);
                    });
                    sendListXls = catListExpExcel;
                    this.expCatListExcel(sendListXls);
                } else {
                    sendListXls.push(this.selectedCatalogName);
                    this.expCatListExcel(sendListXls);
                }
            } else if (this.fromCatalogsList) {
                this.items.forEach(element => {
                    catListExpExcel.push(element.name);
                });
                sendListXls = catListExpExcel;
                this.$store.commit("catalogs/setFromCatList", true);
                this.expCatListJson(sendListXls);
            } else {
                sendListXls.push(this.selectedCatalogName);
                this.$store.commit("catalogs/setFromCatList", false);
                this.expCatListJson(sendListXls);
            }
        },

        showSuccessNotify() {
            this.$toast.showNotify({
                type: "success",
                message: this.$t("catalogs.importExport.successImport")
            });
        }
    }
};
